<template>
	<div style="min-height: 70vh; max-height: 80vh">
		<vs-row vs-w="12">
			<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
				<vx-card class="custom-height mt-4">
					<p class="g-label--normal mb-4">
						<vs-alert
							class="g-small--customize text-success"
							closable
							icon-pack="feather"
							close-icon="icon-x"
							color="success"
							:active.sync="activeAlert2"
							:title="$t('Reports.GenerateReport')"
						>
							{{ $t("Reports.GenerateReportInfo") }}
						</vs-alert>
					</p>
					<div class="vx-row">
						<div :class="selectedCardReport !== null ? 'vx-col md:w-2/3 w-full' : 'vx-col w-full'">
							<vx-card no-shadow card-border class="custom-height">
								<vue-perfect-scrollbar class="scroll-area--content-left" :settings="settings">
									<div class="vx-row">
										<div
											class="vx-col w-1/3 md:w-1/3 xl:w-2/6"
											:class="selectedCardReport !== null ? '' : 'flex justify-center'"
											v-for="report in typeReports"
											:key="report.value"
										>
											<report-card
												hideChart
												class="mb-base"
												icon="EyeIcon"
												:statistic="report.label"
												:typeReport="report.value"
												:statisticTitle="typeSelctionResource(report.typeResorce)"
												:description="report.description"
												@handleClickEmit="reportSelected"
												:active="report.active"
											/>
										</div>
									</div>
								</vue-perfect-scrollbar>
							</vx-card>
						</div>
						<div v-if="selectedCardReport !== null" class="vx-col md:w-1/3 w-full">
							<visit-point-assigned-list
								v-if="selectedCardReport === 'visitpoint'"
								class-custom="custom-height-report"
								max-height="230px"
								:visit_point_ids="[]"
							></visit-point-assigned-list>
							<vx-card v-else card-border no-shadow>
								<resource-assigned-list
									class-custom="custom-height-report"
									:resource_ids="[]"
									:search="true"
									:pagination="true"
								></resource-assigned-list>
							</vx-card>
						</div>
					</div>
				</vx-card>
			</vs-col>
		</vs-row>
		<div class="vx-row">
			<div class="vx-col w-full">
				<div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
					<vs-button
						id="btn-submit-report"
						class="vs-con-loading__container g-btn--resourcePopup"
						type="filled"
						color="success"
						:disabled="!isFormValid"
						@click.prevent="activePrompt = true"
						>{{ $t("Reports.SelectFileTitle") }}
					</vs-button>
				</div>
			</div>
		</div>
		<vs-prompt
			:title="$t('Reports.SelectFileTitle')"
			@cancel="closePrompt"
			@accept="acceptPrompt"
			@close="closePrompt"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			:is-valid="isPromptValid"
		>
			<div class="con-exemple-prompt">
				<p class="mb-2" v-show="!visitPointReportSelected">
					{{ $t("Reports.ReportSetDateRange") }} {{ daysRange }} {{ $t("Days") }}
				</p>
				<vs-row vs-w="12" v-show="!visitPointReportSelected">
					<vs-col vs-lg="6" vs-sm="6" vs-xs="6">
						<small class="date-label">{{ $t("InitDate") }}</small>
						<datepicker
							class="mr-2"
							:disabledDates="disabledDatesFrom"
							:language="$vs.rtl ? langHe : langEn"
							name="init-date"
							v-model="init_date"
						></datepicker>
					</vs-col>
					<vs-col vs-lg="6" vs-sm="6" vs-xs="6">
						<small class="date-label">{{ $t("EndDate") }}</small>
						<datepicker
							:language="$vs.rtl ? langHe : langEn"
							:disabled-dates="disabledDates"
							name="end-date"
							v-model="end_date"
							:disabled="!init_date"
						></datepicker>
					</vs-col>
				</vs-row>
				<div class="mt-4">
					<label class="vs-input--label">{{ $t("Reports.ReportSetFileType") }}</label>
					<v-select v-model="payload.type_file" :options="extFileOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'">
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import moduleReport from "@/store/report/moduleReport.js";
import Commons from "@/helpers/commons.js";
import DateUtils from "@/helpers/DateUtils.js";
import ReportCard from "./ReportCard.vue";
import Report from "@/models/Report.js";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList.vue";
import ResourceAssignedList from "../resource/user-list/ResourceAssignedList";

export default {
	components: {
		ResourceAssignedList,
		VuePerfectScrollbar,
		flatPickr,
		vSelect,
		Datepicker,
		Treeselect,
		ReportCard,
		VisitPointAssignedList,
	},
	data() {
		return {
			payload: new Report({}),
			activeAlert: true,
			activeAlert2: true,
			activeItem: 0,
			disabledFrom: false,
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
			},
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			langHe: es,
			langEn: en,
			update: false,
			selectedCardReport: null,
			extFileOptions: ["xlsx", "csv", "txt"],
			activePrompt: false,
			activeAlertLogin: true,
			init_date: "",
			end_date: "",
			disabledDates: {
				to: new Date(2022, 7, 5), // Disable all dates up to specific date
				from: new Date(2022, 7, 27), // Disable all dates after specific date
				//days: [6, 0], // Disable Saturday's and Sunday's
			},
			daysRange: 89,
			visitPointReportSelected: false,
		};
	},

	computed: {
		typeReports() {
			return [
				{
					label: "Login Logout",
					value: "loginout",
					active: false,
					typeResorce: "General",
					description: "",
				},
				{
					label: "Scheduled Route",
					value: "scheduledroute",
					active: false,
					typeResorce: "Single",
					description: "",
				},
				{
					label: "Scheduled Route vs Executed",
					value: "scheduledroutevsexecuted",
					active: false,
					typeResorce: "Single",
					description: "",
				},
				{
					label: "Location",
					value: "location",
					active: false,
					typeResorce: "Multiple",
					description: this.$t("Reports.LocationDescription"), //"Reporte que retorna la ultima posicion de los recursos."
				},
				{
					label: "Historical Position",
					value: "historicalposition",
					active: false,
					typeResorce: "Multiple",
					description: this.$t("Reports.HistoricalpositionDescription"),
				},
				{
					label: "Transmission",
					value: "transmission",
					active: false,
					typeResorce: "Multiple",
					description: this.$t("Reports.TransmissionDescription"),
				},
				{
					label: "VisitPoints",
					value: "visitpoint",
					active: false,
					typeResorce: "Multiple",
					description: this.$t("Reports.VisitpointReportDescription"),
				},
				{
					label: "Resources",
					value: "resource",
					active: false,
					typeResorce: "Multiple",
					description: this.$t("Reports.ResourceReportDescription"),
				},
			];
		},
		isFormValid() {
			if (this.selectedCardReport === "scheduledroutevsexecuted") {
				return !this.errors.any() && this.assignedResources.length > 0;
			}

			if (this.selectedCardReport === "loginout") {
				return !this.errors.any();
			}
			return !this.errors.any() && (this.assignedResources.length > 0 || this.assignedVisitPoints.length > 0);
		},
		isPromptValid() {
			if (this.visitPointReportSelected) {
				return true;
			} else {
				return this.init_date !== null && this.end_date !== null;
			}
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		disabledDatesTo() {
			return {to: new Date(this.init_date)};
		},
		disabledDatesFrom() {
			return {from: new Date()};
		},
		assignedResources() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		typeSelctionResource() {
			return function (params) {
				return this.$t(`Reports.${params}`);
			};
		},
		assignedVisitPoints() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
	},
	methods: {
		reportSelected(val) {
			this.selectedCardReport = val;
			this.typeReports.map((r) => {
				if (r.value === val) {
					r.active = true;
				} else {
					r.active = false;
				}
				return r;
			});
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		openLoadingBtn() {
			Commons.openLoadingButton.call(this, "btn-submit-report");
		},
		closeLoadingBtn() {
			Commons.closeLoadingButton.call(this, "btn-submit-report");
		},
		cancel() {
			this.selectedCardReport = null;
			this.payload = new Report({});
		},
		acceptPrompt() {
			if (this.selectedCardReport === "visitpoint" || this.selectedCardReport === "resource") {
				this.generateResourceOrVisitPointsReport();
			} else {
				this.submitData();
			}
		},
		closePrompt() {},
		submitData() {
			const ids = this.assignedResources.map((r) => r.id);
			const report_type = this.selectedCardReport;
			const init_date = DateUtils.toDefaultDateTime(this.init_date, "YYYY-MM-DD");
			let end_date = DateUtils.toDefaultDateTime(this.end_date, "YYYY-MM-DD");
			const type_file = this.payload.type_file;
			const locale = this.$i18n.locale;
			this.payload = new Report({
				ids,
				report_type,
				init_date,
				end_date,
				type_file,
				language: locale.toUpperCase(),
			});
			delete this.payload.id;
			delete this.payload.url_file;
			delete this.payload.report_type;
			this.openLoading();
			this.$store
				.dispatch("moduleReport/createReport", {
					reportType: this.selectedCardReport,
					payload: this.payload,
				})
				.then((res) => {
					if (!res.data) {
						this.closeLoading();
						this.$vs.notify({
							color: "warning",
							title: this.$t("Reports.NoDataReportTitle"),
							text: this.$t("Reports.NoDataReport"),
						});
						return;
					}
					if (res.data.length == 0) {
						this.closeLoading();
						this.$vs.notify({
							color: "warning",
							title: this.$t("Reports.NoDataReportTitle"),
							text: this.$t("Reports.NoDataReportInDates"),
						});
						return;
					}
					if (Object.hasOwnProperty.call(res.data, "job_id")) {
						this.closeLoading();
						this.$vs.notify({
							color: "success",
							title: this.$t("Reports.Reports"),
							text: `${this.$t("Reports.ReportGeneratedTitle")}, ${this.$t(
								"Reports." + this.selectedCardReport
							)}`,
							fixed: true,
						});
						return;
					}
					const url = res.data.bucket_path;
					downloadFileFromFirebase(url)
						.then((res) => {
							const fileLink = document.createElement("a");
							fileLink.href = res;
							fileLink.setAttribute("download", "file");
							document.body.appendChild(fileLink);
							fileLink.click();
							document.body.removeChild(fileLink);
							this.closeLoading();
							fileLink.remove();
							this.$vs.notify({
								color: "success",
								title: this.$t("Reports.ReportGeneratedTitle"),
								text: this.$t("Reports.ReportGeneratedText"),
							});
						})
						.catch((error) => {
							this.closeLoading();
							this.handleDownloadError(error);
						});
				})
				.catch((error) => {
					console.error(error);
					this.closeLoading();
					error.data
						? this.handleGetReportError(error.data.reason)
						: this.handleGetReportError(error.message);
				});
		},
		handleDownloadError(error) {
			// A full list of error codes is available at
			switch (error.code) {
				case "storage/object-not-found":
					// File doesn't exist
					this.errorNotify("File doesn't exist");
					break;
				case "storage/unauthorized":
					// User doesn't have permission to access the object
					this.errorNotify("User doesn't have permission to access the object");
					break;
				case "storage/canceled":
					// User canceled the upload
					this.errorNotify("User canceled the upload");
					break;
				case "storage/unknown":
					// Unknown error occurred, inspect error.serverResponse
					// "Ocurrió un error inesperado durante la carga del archivo"
					this.errorNotify("Unknown error occurred, inspect error.serverResponse");
					break;
			}
		},
		handleGetReportError(reason = "Error") {
			switch (reason) {
				case "date range exceeds ninety (90) days":
					this.errorNotify(this.$t("Reports.RangeExceeds"));
					break;
				case "The end_date must be less than today":
					this.errorNotify(this.$t("Reports.EndDateLessToday"));
					break;
				case "missing fields: ['date']":
					this.errorNotify(this.$t("Reports.DateRequired"));
					break;
				case "The end_date must be greater than init_date":
					this.errorNotify(this.$t("Reports.EndDateGreaterInitDate"));
					break;
				case "The date must be less than today":
					this.errorNotify(this.$t("Reports.DateInitMustBeLessToday"));
					break;
				case "resource_id can't have more than 10 resources":
					this.errorNotify(this.$t("Reports.MaxResourcesReached"));
					break;
				default:
					this.errorNotify(reason);
					break;
			}
		},
		errorNotify(message) {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Reports.Error"),
				text: message,
				fixed: false,
				time: 8000,
			});
		},
		/**
		 * @param{String} stringTime 01:00:45
		 */
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validateEndHour(value, args) {
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.alarm_local.init_hour);
		},
		validateInitHour(value, args) {
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.alarm_local.end_hour);
		},
		generateOptionsMulti(rows) {
			this.optionsMulti = Commons.generateSelectOptios(rows, "name", "cartodb_id");
		},
		addDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		subtractDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() - dayNums);
		},
		generateResourceOrVisitPointsReport() {
			const type_file = this.payload.type_file;
			const payload = {
				type_file,
			};
			if (this.selectedCardReport === "visitpoint")
				payload["visit_points_id"] = this.assignedVisitPoints.map((avp) => avp.id);
			if (this.selectedCardReport === "resource")
				payload["resources_id"] = this.assignedResources.map((r) => r.id);
			this.openLoading();
			this.$store
				.dispatch(`moduleReport/createReport`, {reportType: this.selectedCardReport, payload})
				.then((res) => {
					if (!res.data) {
						this.closeLoading();
						this.$vs.notify({
							color: "warning",
							title: this.$t("Reports.NoDataReportTitle"),
							text: this.$t("Reports.NoDataReport"),
						});
						return;
					}
					if (res.data.length == 0) {
						this.closeLoading();
						this.$vs.notify({
							color: "warning",
							title: this.$t("Reports.NoDataReportTitle"),
							text: this.$t("Reports.NoDataReportInDates"),
						});
						return;
					}
					if (Object.hasOwnProperty.call(res.data, "job_id")) {
						this.closeLoading();
						this.$vs.notify({
							color: "success",
							title: this.$t("Reports.Reports"),
							text: `${this.$t("Reports.ReportGeneratedTitle")}, ${this.$t(
								"Reports." + this.selectedCardReport
							)}`,
							fixed: true,
						});
						return;
					}
				})
				.catch((error) => {
					console.error(error);
					this.closeLoading();
					error.data
						? this.handleGetReportError(error.data.reason)
						: this.handleGetReportError(error.message);
				});
		},
	},
	watch: {
		selectedCardReport(val) {
			if (val === "visitpoint" || val === "resource") {
				this.visitPointReportSelected = true;
			} else {
				this.visitPointReportSelected = false;
			}
		},
		init_date(date) {
			const currentDate = new Date();
			const dateStr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

			// Calculate new dates with 30 days after and before the selected date
			const dateFromMilliseconds = this.addDaysToDate(dateStr, this.daysRange);
			const dateToMilliseconds = this.subtractDaysToDate(dateStr, this.daysRange);

			// Parse milliseconds dates to string format
			const dateFrom = DateUtils.toDefaultDateTime(new Date(dateFromMilliseconds), "YYYY-MM-DD");
			const dateTo = DateUtils.toDefaultDateTime(new Date(dateToMilliseconds), "YYYY-MM-DD");

			// Calculate difference in days between current and selected date
			const difference = currentDate.getTime() - date.getTime();
			const days = Math.ceil(difference / (1000 * 3600 * 24));

			if (days > this.daysRange) {
				this.disabledDates.from = new Date(dateFrom); // Disable all dates after specific date
				this.disabledDates.to = new Date(date); // Disable all dates up to specific date
			} else {
				this.disabledDates.from = new Date(currentDate); // Disable all dates after specific date
				this.disabledDates.to = new Date(date); // Disable all dates up to specific date
			}
		},
	},
	created() {
		// register Module Group
		if (!moduleReport.isRegistered) {
			this.$store.registerModule("moduleReport", moduleReport);
			moduleReport.isRegistered = true;
		}
		// register Module Common
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}
		// register Module VisitPoint
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
	},
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 52010;
	}

	::v-deep .vs-sidebar {
		z-index: 52010;
		width: 400px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}

.scroll-area--data-list-add-new {
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.scroll-area {
	margin: auto;
	max-height: 450px;
}

.scroll-area--content-left {
	margin: auto;
	max-height: 430px;
}

.custom-height {
	min-height: 80vh;
}

@media (min-width: 508px) and (max-width: 988px) {
	.scroll-area--content-left .vx-row {
		display: grid;
		grid-template-columns: 1fr 1fr;
		justify-content: center;
		align-items: center;
	}
}

@media (max-width: 507px) {
	.scroll-area--content-left .vx-row {
		display: grid;
		grid-template-columns: 1fr;
		justify-content: center;
		align-items: center;
	}
}
</style>
